<template>
  <v-container-principal>
    <div class="font-weight-black primary--text text-h5 mb-3">
      <v-btn :icon="true" @click="() => this.$router.go(-1)">
        <v-icon class="text-h4" color="black">$prev</v-icon>
      </v-btn>
      {{ id ? "Editar Sala" : "Criar Sala" }}
    </div>

    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-form>
        <v-row>
          <v-col md="3">
            <ValidationProvider
              name="Disponibilidade"
              rules="required"
              v-slot="{ errors, valid }">
              <v-radio-group
                label="Status"
                v-model="sala.disponivel"
                :error-messages="errors"
                :success="valid">
                <v-radio :value="true" label="Disponível para reserva" />
                <v-radio :value="false" label="Indisponível para reserva" />
              </v-radio-group>
            </ValidationProvider>
          </v-col>

          <v-col md="3">
            <ValidationProvider
              name="Moderacao"
              rules="required"
              v-slot="{ errors, valid }">
              <v-radio-group
                label="Moderação"
                v-model="sala.moderacao"
                :error-messages="errors"
                :success="valid">
                <v-radio :value="true" label="Com moderação" />
                <v-radio :value="false" label="Sem moderação" />
              </v-radio-group>
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="6">
            <ValidationProvider
              name="Nome"
              rules="required"
              v-slot="{ errors, valid }">
              <v-text-field
                label="Nome ou número da sala"
                placeholder="ex: Sala de aula 01"
                outlined
                v-model="sala.nome"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="6">
            <ValidationProvider
              name="Responsável"
              rules="required"
              v-slot="{ errors, valid }">
              <v-autocomplete
                label="Nome do Responsável da sala"
                placeholder="ex: Biblioteca"
                outlined
                v-model="sala.responsavel"
                :items="possiveisResponsaveis"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="6">
            <ValidationProvider
              name="Computadores"
              rules="required"
              v-slot="{ errors, valid }">
              <v-text-field
                type="number"
                min="1"
                placeholder="Quantidade de computadores"
                label="Quantidade de computadores ?"
                outlined
                v-model="sala.computadores"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="2">
            <ValidationProvider
              name="Bloco"
              rules="required"
              v-slot="{ errors, valid }">
              <v-select
                :items="blocos"
                outlined
                label="Qual bloco ?"
                v-model="sala.bloco.id"
                item-value="id"
                item-text="attributes.descricao"
                @change="getBloco"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>

          <v-col md="2">
            <ValidationProvider
              name="Piso"
              rules="required"
              v-slot="{ errors, valid }">
              <v-select
                :items="andares"
                outlined
                label="Qual piso ?"
                v-model="sala.andar"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>

          <v-col md="2">
            <ValidationProvider
              name="Capacidade"
              rules="required|min_capacidade:1"
              v-slot="{ errors, valid }">
              <v-text-field
                type="number"
                min="1"
                placeholder="No mínimo 1"
                label="Capacidade máxima?"
                outlined
                v-model="sala.capacidade"
                :error-messages="errors"
                :success="valid" />
            </ValidationProvider>
          </v-col>
        </v-row>

        <div class="font-weight-bold primary--text text-h5">Equipamentos</div>
        <v-checkbox v-model="sala.projetor" label="Projetor" />
        <v-checkbox
          v-model="sala.arcondicionado"
          label="Ar-condicionado"
          class="my-0" />
        <v-checkbox class="my-0" v-model="sala.mesa" label="Mesa" />
        <v-checkbox class="my-0" v-model="sala.lousa" label="Lousa" />

        <v-row>
          <v-col md="6">
            <v-textarea
              name="input-7-1"
              label="Observações"
              v-model="sala.observacoes"
              hint="Digite aqui qualquer observação sobre a sala"></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col md-6>
            <v-btn outlined x-large color="primary" to="/salas" class="mr-3">
              Cancelar</v-btn
            >
            <v-btn
              @click.prevent="salvarSala"
              depressed
              x-large
              color="primary"
              :disabled="invalid">
              Salvar informações
            </v-btn>
          </v-col>
          <v-col v-if="id" md-6>
            <v-row justify="end">
              <v-btn
                v-if="isAdministrador"
                @click.prevent="dialogDelete = true"
                x-large
                plain
                color="red"
                class="my-3">
                Excluir Sala</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>

    <v-delete-sala-dialog
      :visivel="dialogDelete"
      @close="dialogDelete = false"
      @confirma="excluirSala(), (dialogDelete = false)" />
  </v-container-principal>
</template>

<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory"
import { mapActions, mapGetters } from "vuex"
import VContainerPrincipal from "../../components/VContainerPrincipal"
import VDeleteSalaDialog from "@/components/dialogs/sala/VDeleteSalaDialog.vue"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import messageMixin from "@/mixins/translateMessageMixin"
import userRepository from "../../repositories/usuarioRepository"

const salaRepository = RepositoryFactory.get("sala")
const blocoRepository = RepositoryFactory.get("bloco")
const INFOS_SALVAS_SUCESSO = "As informações foram salvas com sucesso!"
const SALA_EXCLUIDA_SUCESSO = "A exclusão da sala foi realizada com sucesso!"
const BLOCO_NAO_SELECIONADO = "Bloco não selecionado."
const ADMINISTRADOR = "ADMINISTRADOR"

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VContainerPrincipal,
    VDeleteSalaDialog,
  },

  mixins: [messageMixin],

  props: ["id"],

  data() {
    return {
      sala: {
        nome: "",
        responsavel: null,
        disponivel: true,
        bloco: { id: null },
        andar: null,
        capacidade: null,
        computadores: null,
        projetor: false,
        arcondicionado: false,
        mesa: false,
        lousa: false,
        moderacao: true,
        observacoes: "",
      },
      blocos: [],
      andares: [],
      feedbackDelete: false,
      dialogDelete: false,
      possiveisResponsaveis: [],
      buscaResponsavel: null,
    }
  },

  async created() {
    const response = await blocoRepository.getAll()
    this.blocos = response.data.data

    if (this.id) {
      salaRepository.getOne(this.id).then((response) => {
        const sala = response.data.data.attributes
        this.sala.nome = sala.nome
        this.sala.responsavel = sala.responsavel.data.id
        this.sala.computadores = sala.computadores
        this.sala.disponivel = sala.disponivel
        this.sala.bloco.id = sala.bloco.data.id
        this.sala.andar = sala.andar
        this.sala.capacidade = sala.capacidade
        this.sala.projetor = sala.projetor
        this.sala.arcondicionado = sala.arcondicionado
        this.sala.mesa = sala.mesa
        this.sala.lousa = sala.lousa
        this.sala.moderacao = sala.moderacao
        this.sala.observacoes = sala.observacoes

        if (!this.isResponsavel && !this.isPrefeitura) {
          return this.$router.replace("/acessoNegado")
        }

        const blocoDaSala = this.blocos.find((b) => b.id === sala.bloco.data.id)
        this.atualizaAndares(blocoDaSala)
      })
    }
  },

  async mounted() {
    this.sala.responsavel = this.userId
    this.getResponsavel()
  },

  methods: {
    salvarSala() {
      if (this.id) {
        salaRepository
          .update(this.id, { data: this.sala })
          .then(() => {
            this.showSucesso(INFOS_SALVAS_SUCESSO)
            this.$router.push("/salas")
          })
          .catch(({ response }) => {
            if (response.status === 500) {
              this.showErro(BLOCO_NAO_SELECIONADO)
            } else {
              this.showErro(this.getMessage(response.data.error.message))
            }
          })
      } else {
        salaRepository
          .create({ data: this.sala })
          .then(() => {
            this.showSucesso(INFOS_SALVAS_SUCESSO)
            this.$router.push("/salas")
          })
          .catch(({ response }) => {
            if (response.status === 500) {
              this.showErro(BLOCO_NAO_SELECIONADO)
            } else {
              this.showErro(this.getMessage(response.data.error.message))
            }
          })
      }
    },

    excluirSala() {
      salaRepository.delete(this.id).then(() => {
        this.showSucesso(SALA_EXCLUIDA_SUCESSO)
        this.$router.push("/salas")
      })
    },

    async getBloco() {
      const { data } = await blocoRepository.getOne(this.sala.bloco.id)
      this.sala.andar = null
      return this.atualizaAndares(data.data)
    },

    atualizaAndares(bloco) {
      this.andares = []
      this.andares = Array.from(
        { length: bloco.attributes.quantidadeAndar },
        (v, k) => k + 1
      )
    },

    getResponsavel(responsavel) {
      userRepository.getAllByName(responsavel, ADMINISTRADOR).then((res) => {
        this.possiveisResponsaveis = res.map((usuario) => ({
          text: usuario.username,
          value: usuario.id,
        }))
      })
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },

  computed: {
    isResponsavel() {
      return this.userId === this.sala.responsavel
    },
    ...mapGetters({
      nome: ["auth/username"],
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
      userId: ["auth/userId"],
    }),
  },

  watch: {
    buscaResponsavel(resp) {
      this.getResponsavel(resp)
    },
  },
}
</script>
